export default __webpack_public_path__ + "static/media/notifications_setting.7730adde.png";